export const GENUINE_PARTS = {
  isuzuGenuinePart: {
    src: 'https://assets.isuzu-tis.com/isuzu_genuine_parts_97a8f266a9.svg',
    alt: 'Isuzu Genuine Parts',
    dimension: {
      width: 64,
      height: 28,
    },
    dataTrackValue: 'part-item-isuzu',
    type: 'isuzu-logo',
    title: 'อะไหล่แท้อีซูซุ',
    description:
      '<p>คุณภาพเดียวกับอะไหล่ที่ติดตั้งมากับตัวรถ ทดสอบและรับรองโดย บริษัท อีซูซุมอเตอร์ จำกัด (ประเทศญี่ปุ่น)</p>',
  },
  tripetchGenuinePart: {
    src: 'https://assets.isuzu-tis.com/tripetch_genuine_parts_47b4ee5067.svg',
    alt: 'Tri Petch Genuine Parts',
    dimension: {
      width: 156,
      height: 28,
    },
    dataTrackValue: 'part-item-tripetch',
    type: 'tripetch-logo',
    title: 'อะไหล่แท้ตรีเพชร',
    description:
      '<p>อะไหล่ทางเลือกราคาย่อมเยา ทดสอบและรับรองคุณภาพโดยบริษัท ตรีเพชรอีซูซุเซลส์ จำกัด ครอบคลุมงานซ่อมบำรุงกว่า 1,000 รายการ</p>',
  },
  bvpGenuinePart: {
    src: 'https://assets.isuzu-tis.com/best_value_parts_529fc0b7c3.svg',
    alt: 'Best Value Parts',
    dimension: {
      width: 64,
      height: 28,
    },
    dataTrackValue: 'part-item-bvp',
    type: 'bvp-logo',
    title: 'อีซูซุเบสท์แวรลู',
    description:
      '<p>อะไหล่ทางเลือกราคาย่อมเยา ทดสอบและรับรองคุณภาพโดยบริษัท อีซูซุมอเตอร์ จำกัด (ประเทศญี่ปุ่น)</p>',
  },
};
